var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownDoubleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 40,
    height: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 3.33594,
    y: 14.333,
    width: 33.3333,
    height: 33.3333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.7763 26.9648L19.9995 35.0199L7.22266 26.9648",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 3.33594,
    y: 3.33301,
    width: 33.3333,
    height: 33.3333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.7763 15.9648L19.9995 24.0199L7.22266 15.9648",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDoubleArrow);
export default __webpack_public_path__ + "static/media/down_double_arrow.f27dabc916a4504f1a665aa67a05de7e.svg";
export { ForwardRef as ReactComponent };